/**
 * Erros dos endpoints de cadastro de grupos de cliente e de endereços:
 * `POST /admin/customer-groups/import`, `/clients/{clientId}/addresses` e `PUT /clients/{id}` com `customerGroupId`.
 */

interface ApiErrorLike {
  response?: {
    status?: number;
    data?: {
      message?: unknown;
      errors?: unknown;
    };
  };
}

export interface FieldError {
  field: string;
  message: string;
}

/** Erros de campo do 400 de validação (`errors: [{ field, message }]`), com `field` em camelCase. */
export function getFieldErrors(error: unknown): FieldError[] {
  const response = (error as ApiErrorLike)?.response;
  if (response?.status !== 400 || !Array.isArray(response.data?.errors)) return [];
  return response.data.errors
    .filter((item): item is FieldError => typeof item?.field === "string" && typeof item?.message === "string")
    .map((item) => ({ field: item.field, message: item.message }));
}

/** `code` do 409 (ex.: `customer_group_code_taken`), para ligar o erro ao campo certo do formulário. */
export function getCustomerRegistrationConflictCode(error: unknown): string | null {
  const response = (error as ApiErrorLike & { response?: { data?: { code?: unknown } } })?.response;
  if (response?.status !== 409) return null;
  const code = response.data?.code;
  return typeof code === "string" ? code : null;
}

/** Mensagem para toast quando uma ação de endereço ou grupo é recusada pela API. */
export function getCustomerRegistrationErrorMessage(error: unknown, fallback: string): string {
  const response = (error as ApiErrorLike)?.response;
  const message: unknown = response?.data?.message;
  switch (response?.status) {
    case 400: {
      const fields = getFieldErrors(error);
      if (fields.length > 0) return fields.map((item) => item.message).join(" ");
      return typeof message === "string" ? message : fallback;
    }
    case 404:
      return typeof message === "string" ? message : "Registro não encontrado. Atualize a página.";
    case 409:
    case 413:
      return typeof message === "string" ? message : fallback;
    case 403:
      return "Você não tem permissão para esta ação.";
    case 415:
      return "Envie o arquivo como CSV.";
    default:
      return fallback;
  }
}
